import { axiosInstance } from "./axiosInstance";

export const FAQ_API = (page) => {
	const url = `/api/faq`;
	const data = axiosInstance.get(url);
	return data;
};
